// https://github.com/Kitware/vtk-js/blob/2617c3af6db19fc94e8c143565df58eb7d7a498a/Sources/Rendering/Core/ColorTransferFunction/ColorMaps.js
import lbtColorMaps from './lbtColorMaps.json'

const presetMap = Object.create(null)

lbtColorMaps
  .filter((p) => p.RGBPoints)
  .forEach((p) => {
    presetMap[p.Name] = p
  })

const rgbPresetNames = Object.keys(presetMap)

function getPresetByName(name: string) {
  return presetMap[name]
}


function getPresetReverse(name: string) {
  const preset = presetMap[name]
  const stops = preset.RGBPoints.filter((p, i) => i % 4 === 0).reverse()
  preset.RGBPoints.map((v, i) => {
    if(i % 4 === 0) {
      return stops[i / 4]
    }
    return v
  })
  return preset
}

// ----------------------------------------------------------------------------

function addPreset(preset: any) {
  if (!preset.RGBPoints || preset.ColorSpace === 'CIELAB') {
    return
  }

  if (!presetMap[preset.Name]) {
    rgbPresetNames.push(preset.Name)
    rgbPresetNames.sort()
  }

  presetMap[preset.Name] = preset
}

// ----------------------------------------------------------------------------

function removePresetByName(name: string) {
  const index = rgbPresetNames.indexOf(name)
  if (index > -1) {
    rgbPresetNames.splice(index, 1)
  }
  delete presetMap[name]
}

// ----------------------------------------------------------------------------

const colorMaps = {
  addPreset,
  removePresetByName,
  getPresetByName,
  getPresetReverse,
  rgbPresetNames,
}

export default colorMaps
